<template>
  <custom-modal-tailwind
    :visible="visible"
    :title="$t('TRANSLATION_CONFIG.AddLanguage')"
    :ok-text="$t('TRANSLATION_CONFIG.Save')"
    :cancel-text="$t('TRANSLATION_CONFIG.Cancel')"
    ok-variant="primary"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div style="margin-bottom: 1rem;">
        <label for="lang-code" style="display: block; margin-bottom: 0.5rem; color: #d0d2d6; font-size: 0.875rem;">
          {{ $t('TRANSLATION_CONFIG.LanguageCode') }}
        </label>
        <input
          id="lang-code"
          v-model="form.code"
          type="text"
          placeholder="Ex: fr_FR"
          required
          style="width: 100%; padding: 0.5rem 0.75rem; border: 1px solid #3b4253; border-radius: 0.375rem; background-color: #283046; color: #d0d2d6; font-size: 0.875rem; outline: none;"
          @focus="$event.target.style.borderColor = '#7367f0'"
          @blur="$event.target.style.borderColor = '#3b4253'"
        />
      </div>

      <div style="margin-bottom: 0;">
        <label for="lang-label" style="display: block; margin-bottom: 0.5rem; color: #d0d2d6; font-size: 0.875rem;">
          {{ $t('TRANSLATION_CONFIG.LanguageLabel') }}
        </label>
        <input
          id="lang-label"
          v-model="form.label"
          type="text"
          placeholder="Ex: Francês"
          required
          style="width: 100%; padding: 0.5rem 0.75rem; border: 1px solid #3b4253; border-radius: 0.375rem; background-color: #283046; color: #d0d2d6; font-size: 0.875rem; outline: none;"
          @focus="$event.target.style.borderColor = '#7367f0'"
          @blur="$event.target.style.borderColor = '#3b4253'"
        />
      </div>
    </form>
  </custom-modal-tailwind>
</template>

<script>
import CustomModalTailwind from '@/@core/components/CustomModalTailwind/CustomModalTailwind.vue'

export default {
  name: 'NewLanguageModal',
  components: {
    CustomModalTailwind
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        code: '',
        label: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      if (!this.form.code || !this.form.label) {
        return
      }
      
      this.$emit('save', { ...this.form })
      
      // Reset form
      this.form.code = ''
      this.form.label = ''
      
      this.$emit('close')
    },
    handleCancel() {
      // Reset form on cancel
      this.form.code = ''
      this.form.label = ''
      this.$emit('close')
    }
  }
}
</script>
